<h3>Filtrar por categorías</h3>
<mat-dialog-content>
    <mat-form-field appearance="standard">
        <mat-label>Categorías</mat-label>
        <mat-select [(ngModel)]="tagsField" #tagsSelect (selectionChange)="aceptarTags()">
            <mat-option value="">Todas</mat-option>
            <mat-option *ngFor="let tag of tags.registros; let i = index;" [value]="tag.idmodelo">{{ tag.marca_modelo }}</mat-option>
            <!--
            <div class="position-sticky bottom-0 start-50 p-2 bg-white d-flex justify-content-center">
                <button mat-raised-button color="accent" (click)="tagsSelect.close()">Aceptar</button>
            </div>
            -->
        </mat-select>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <!--<button mat-raised-button color="accent" (click)="aceptarTags()">Aceptar</button>-->
    <button mat-raised-button color="warn" mat-dialog-close>Cancelar</button>
</mat-dialog-actions>